import useCurrencies from "./useCurrencies";

export default useCurrencies;
